import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Asidebar, Navbar } from "./components";
import MainDashboard from "./view/MainDashboard";
import { useState } from "react";
import Bridge from "./view/Bridge";
import { Helmet } from "react-helmet";
import AddChainPage from "./view/AddChainPage";
import { isMobile } from "./utils/helper";

function App() {
  const robotsMeta = process.env.REACT_APP_ROBOTS || "noindex,nofollow";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  if (window.matchMedia("(max-width: 1250px)").matches) {
    if (isMobileMenuOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content={robotsMeta} />
      </Helmet>
      <Router>
        <div className="relative laptop:grid gap-4 h-full laptop:min-h-screen p-4">
          <Asidebar
            isMenuOpen={isMobileMenuOpen}
            setIsMenuOpen={setIsMobileMenuOpen}
          />

          <div className="block laptop:hidden mb-5">
            <Navbar
              isMenuOpen={isMobileMenuOpen}
              setIsMenuOpen={setIsMobileMenuOpen}
            />
          </div>

          <main className="relative h-full bg-[#E8E9E9] p-4 md:p-5 z-[5] laptop:ml-[320px] laptop:w-[calc(100%-320px)] rounded-2xl lg:rounded-[20px] overflow-hidden pt-10 lg:pt-16 laptop:pt-16">
            <div className="absolute top-0 left-0 w-full h-[700px] bg-subPagebg bg-no-repeat bg-cover before:absolute before:bottom-0 before:left-0 before:w-full before:h-1/2 before:bg-lightOverlay bg-bottom"></div>

            <div className="hidden">
              <Navbar />
            </div>
            <Routes>
              <Route path="/" element={<MainDashboard />} />
              <Route path="/bridge" element={<Bridge />} />
              <Route path="/*" element={<Navigate to={"/"} />} />
              {isMobile() && <Route path="/add-chain" element={<AddChainPage />} />}
            </Routes>
          </main>
        </div>
      </Router>
    </>
  );
}

export default App;
